/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim1VIcon16Light } from './ArrowDim1VIcon16Light';
import { ArrowDim1VIcon16Regular } from './ArrowDim1VIcon16Regular';
import { ArrowDim1VIcon16Solid } from './ArrowDim1VIcon16Solid';
import { ArrowDim1VIcon20Light } from './ArrowDim1VIcon20Light';
import { ArrowDim1VIcon20Regular } from './ArrowDim1VIcon20Regular';
import { ArrowDim1VIcon20Solid } from './ArrowDim1VIcon20Solid';
import { ArrowDim1VIcon24Regular } from './ArrowDim1VIcon24Regular';
import { ArrowDim1VIcon24Solid } from './ArrowDim1VIcon24Solid';
import { ArrowDim1VIcon32Regular } from './ArrowDim1VIcon32Regular';
import { ArrowDim1VIcon64Regular } from './ArrowDim1VIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim1VIcon16Light,
        regular: ArrowDim1VIcon16Regular,
        solid: ArrowDim1VIcon16Solid,
    },
    20: {
        light: ArrowDim1VIcon20Light,
        regular: ArrowDim1VIcon20Regular,
        solid: ArrowDim1VIcon20Solid,
    },
    24: {
        regular: ArrowDim1VIcon24Regular,
        solid: ArrowDim1VIcon24Solid,
    },
    32: {
        regular: ArrowDim1VIcon32Regular,
    },
    64: {
        regular: ArrowDim1VIcon64Regular,
    },
};
export var ArrowDim1VIcon = forwardRef('ArrowDim1VIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
